import { useAtomValue } from 'jotai';

import type { AuthSessionMetadata } from '../../contracts';
import { authSessionMetadataAtom } from '../atoms';

/**
 * Reactive subscription to the cached session metadata
 * (`{ accessToken, user, userRefId, kindeUserId, region, ... }`).
 * Returns `null` when the cache is empty (loading, unauthenticated, or
 * boot-transient).
 *
 * Replaces the metadata return path of `useAuth0Session()` for
 * non-token consumers. New consumers should read from here; legacy
 * consumers go through the `useAuth0Session` shim, which is layered
 * on top of this hook.
 */
export function useAuthSessionMetadata(): AuthSessionMetadata | null {
  return useAtomValue(authSessionMetadataAtom);
}
